<div class="form-group mt-auto" [ngClass]="{ 'invalid-control': invalid }">
  <ng-container *ngIf="label">
    <app-label-info>{{ label }}</app-label-info>
  </ng-container>

  <div
    class="custom-control custom-checkbox pb-2"
    [class.custom-control-inline]="_horizontal"
    *ngFor="let option of options; let i = index"
  >
    <input
      type="checkbox"
      [value]="option"
      (change)="onCheckChange($event, i)"
      (blur)="onBlur()"
      name="{{ groupName + i }}"
      id="{{ groupName + i }}"
      [checked]="isValueSelected(option)"
      class="custom-control-input"
      [disabled]="isDisabled(option?.id)"
    />

    <label class="custom-control-label" for="{{ groupName + i }}">{{ option?.value }}</label>
  </div>

  <partnerhub-error-validation *ngIf="invalid" [errors]="errors"> </partnerhub-error-validation>
</div>
